import { useNotification } from "../hooks/useNotification";
import { useEffect } from "react";

export default function NotificationList() {
  const { notifications, loading, error, fetchNotifications, markNotificationAsSeen } = useNotification();

  useEffect(() => {
    (async () => {
      await fetchNotifications();
      markNotificationAsSeen();
    })();
  }, []);

  // Group notifications by date
  const groupNotificationsByDate = (notifications) => {
    const today = new Date().toDateString();
    const yesterday = new Date(Date.now() - 86400000).toDateString();

    const grouped = {
      today: [],
      yesterday: [],
      older: [],
    };

    notifications.forEach((notification) => {
      const notificationDate = new Date(notification.createdAt).toDateString();

      if (notificationDate === today) {
        grouped.today.push(notification);
      } else if (notificationDate === yesterday) {
        grouped.yesterday.push(notification);
      } else {
        grouped.older.push(notification);
      }
    });

    return grouped;
  };

  const groupedNotifications = groupNotificationsByDate(notifications);

  // Render notification card
  const renderNotificationCard = (notification, index) => (
    <div key={index} className="notification-list-card">
      <div className="notification-list-left">
        <div className="notification-icon">
          <i className="fi fi-rr-bell" />
        </div>
        <div>
          <div className="subtitle-1">{notification.title}</div>
          <div className="text-muted-small">{notification.body}</div>
        </div>
      </div>
      <div className="text-muted-small">
        {new Date(notification.createdAt).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </div>
    </div>
  );

  // Render notification group
  const renderNotificationGroup = (title, notificationList) => {
    if (notificationList.length === 0) return null;

    return (
      <>
        <h5 className="subtitle-1 mb-3 text-start">{title}</h5>
        {notificationList.map((notification, index) => renderNotificationCard(notification, `${title}-${index}`))}
      </>
    );
  };

  if (loading) {
    return (
      <div className="main-content">
        <div className="customer-part">
          <div className="card-box">
            <div className="notification notification-list-bg">
              <div className="text-center py-4">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <p className="mt-2">Loading notifications...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="main-content">
        <div className="customer-part">
          <div className="card-box">
            <div className="notification notification-list-bg">
              <div className="text-center py-4">
                <div className="alert alert-danger">
                  <p className="mb-2">Error: {error}</p>
                  <button className="btn btn-primary btn-sm" onClick={fetchNotifications}>
                    Retry
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (notifications?.length === 0) {
    return (
      <div className="main-content">
        <div className="customer-part">
          <div className="card">
            <div className="notification-box">
              <figure>
                <img src="/favicon/notification-img.svg" />
                <h2 className="h2-headline mt-4">No Notification Here</h2>
                <p className="text-gray">These is no notification to show right now.</p>
              </figure>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="main-content">
        <div className="customer-part">
          <div className="card-box">
            <div className="notification notification-list-bg">
              {renderNotificationGroup("Today", groupedNotifications?.today)}
              {renderNotificationGroup("Yesterday", groupedNotifications?.yesterday)}
              {renderNotificationGroup("Earlier", groupedNotifications?.older)}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
